import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MarketplaceOfferCard = ({ offer }) => {
  const { t, i18n } = useTranslation();

  const discountText =
    offer.discountMode === 'PERCENTAGE'
      ? t('marketplace.percentOff', { value: Number(offer.discountValue) })
      : t('marketplace.flatOff', { value: Number(offer.discountValue || 0).toLocaleString() });

  const scopeText =
    offer.scope === 'SERVICES'
      ? t('marketplace.scopeServices')
      : offer.scope === 'PRODUCTS'
        ? t('marketplace.scopeProducts')
        : t('marketplace.scopeBoth');

  return (
    <Link
      to={`/marketplace/offers/${offer._id}`}
      className="flex h-full flex-col overflow-hidden rounded-xl border border-zinc-200 bg-gradient-to-br from-glow-600/20 via-purple-600/10 to-emerald-600/15 outline-none ring-glow-500/40 transition hover:ring-2 focus-visible:ring-2 dark:border-zinc-800"
    >
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-start justify-between gap-3">
          <span className="rounded-full bg-black/10 px-3 py-1 text-xs font-semibold text-zinc-900 dark:bg-white/10 dark:text-zinc-100">
            {discountText}
          </span>
          <span className="text-xs text-zinc-600 dark:text-zinc-400">{scopeText}</span>
        </div>
        <h3 className="mt-3 line-clamp-2 text-lg font-semibold">{offer.bannerText || offer.name}</h3>
        {offer.salonName && (
          <p className="mt-2 truncate text-sm text-zinc-600 dark:text-zinc-400">{offer.salonName}</p>
        )}
        {offer.endAt && (
          <p className="mt-2 text-xs text-zinc-600 dark:text-zinc-500">
            {t('marketplace.ends', { date: new Date(offer.endAt).toLocaleString(i18n.language) })}
          </p>
        )}
        <p className="mt-auto pt-4 text-sm font-medium text-glow-400">{t('marketplace.viewOffer')}</p>
      </div>
    </Link>
  );
};

export default MarketplaceOfferCard;
